<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import GroupingBadge from '@/stay-displayer/grouping/common/GroupingBadge.vue'
import GroupingCard from '@/stay-displayer/grouping/common/GroupingCard.vue'
import GroupingCost from '@/stay-displayer/grouping/common/GroupingCost.vue'
import GroupingErrorBlock from '@/stay-displayer/grouping/common/GroupingErrorBlock.vue'
import GroupingErrorMessage from '@/stay-displayer/grouping/mco/GroupingErrorMessage.vue'
import { ModeEnum } from '@/store/modules/settings/types'
import { Ghm } from '@/store/modules/stay/mco/types'
import { GroupingError } from '@/store/modules/stay/types'

const props = withDefaults(defineProps<{
  mode: string
  ghm?: Ghm
  ghs?: string
  value: number
  moneyGap?: number
  groupingError?: GroupingError
  isProposal?: boolean
}>(), {
  ghm: null,
  ghs: null,
  moneyGap: 0,
  groupingError: null,
  isProposal: false,
})

const { t } = useI18n()

const hasGhmError = computed(() => props.ghm && props.ghm.reference.startsWith('90Z'))
const hasRevaluation = computed(() => props.moneyGap !== 0 && props.mode !== ModeEnum.AUTOMATION)
</script>

<template>
  <grouping-card>
    <template #title>
      <span>{{ t('stayDisplayer.grouping.title') }}</span>
      <small class="ms-1 fs-6">- {{ isProposal ? t('stayDisplayer.mco.diagnosisStatus.proposal') : t('stayDisplayer.mco.diagnosisStatus.current') }}</small>
    </template>
    <template #left>
      <div class="badges-row">
        <grouping-badge
          label="GHM"
          :value="ghm?.reference"
          :variant="hasGhmError ? 'error' : 'primary'"
          :title="ghm?.description"
        />
        <grouping-badge
          label="GHS"
          :value="ghs"
          :variant="hasGhmError ? 'error' : 'secondary'"
        />
      </div>
      <div class="cost-row">
        <grouping-cost
          :cost="value"
          :money-gap="hasRevaluation ? moneyGap : 0"
        />
      </div>
    </template>
    <template #right>
      <slot name="actions" />
      <grouping-error-block
        v-if="hasGhmError && groupingError"
        :errors="[groupingError]"
      />
      <grouping-error-message
        v-else-if="groupingError"
        :is-critical="false"
        :error="groupingError"
      />
    </template>
  </grouping-card>
</template>

<style scoped lang="scss">
.badges-row {
  display: flex;
  gap: 7px;
}

.cost-row {
  padding: 5px 0;
}
</style>
